<template>
    <div class="vuetable-filterbar col-md-12">
	    <div class="form-group p-l">
            <b-container fluid class="p-a-0">
                <b-row no-gutters>
                    <b-col sm="6" md="2" class="m-t-5px p-a-0">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="cd" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Código</label>
                        </div>
                    </b-col>
                    <b-col sm="6" md="2" class="m-t-5px p-a-0">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="cd_erp" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">ERP</label>
                        </div>
                    </b-col>

                    <b-col sm="6" md="2" class="m-t-5px p-a-0">
                        <multiselect v-model="nome"
                        :options="optionsNomePorto"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Nome do Porto"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>

                    <b-col sm="6" md="2" class="m-t-5px p-a-0">
                        <multiselect v-model="municipio"
                        :options="optionsMunicipio"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Nome do Município"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>

                    <b-col sm="6" md="2" class="m-t-5px">
                        <div class="input-group-btn">
                          <div class="btn-group">
                            <button type="button" class="btn btn-secondary btn-outline" @click="doFilter" :disabled="vuetableFilterButton">Filtrar</button>
                            <button type="button" class="btn btn-secondary btn-outline" @click="resetFilter" :disabled="vuetableFilterButton">Limpar</button>
                          </div>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      cd: '',
      cd_erp: '',
      optionsNomePorto: [],
      nome: [],
      optionsMunicipio: [],
      municipio: [],
      data_filter: [],
      helpForm: new Form({statusRecord: [], params: []}),
    }
  },
  mounted() {
      this.getNomePorto();
      this.getMunicipio();
    },
  methods: {
      doFilter () {
          this.$store.commit('setVuetableFilterButton', true);
          this.data_filter = {cd: this.cd,
                              nome: this.nome,
                              cd_erp: this.cd_erp,
                              municipio: this.municipio};
          this.$events.fire('filter-set', this.data_filter);
      },
      resetFilter () {
        this.cd = '';  // clear the text in text input
        this.nome = '';
        this.cd_erp = '';
        this.municipio = '';
        this.$events.fire('filter-reset');
      },
      getNomePorto() {
          this.helpForm.params = { tabela: 'porto',
                                  coluna: 'nome' };

          this.helpForm.get('/api/porto/jsonlist').then(response =>
          {
              new ReturnApi(response, this, true, false, false);
              response.items.forEach((obj)=>
              {
                  this.optionsNomePorto.push({ label: obj.nome, value: obj.porto_id })
              })
          })
          .catch(errors =>
          {
              new ReturnApi(errors, this)
          });
      },
      getMunicipio() {
          this.helpForm.params = { tabela: 'porto',
                                  coluna: 'nome' };

          this.helpForm.get('/api/municipio/jsonlist').then(response =>
          {
              new ReturnApi(response, this, true, false, false);
              response.items.forEach((obj)=>
              {
                  this.optionsMunicipio.push({ label: obj.nome, value: obj.municipio_id })
              })
          })
          .catch(errors =>
          {
              new ReturnApi(errors, this)
          });
      }
  },
  computed: {
      vuetableFilterButton: {
          get () {
              return this.$store.state.vuetable.filterButton;
          },
      },
  }
}
</script>
